import { FilterConditions, INSERT, SELECT, UPDATE , execute} from "@/utils/database_module"
import { logDebug } from "@/utils/helpers";
import { Section ,  Car } from "@/utils/types"
import { log } from "console";

const carsSections = {
    getAll : async (is_admin : boolean ,) => {

       
        const conditions = [ { column: "is_deleted", operator: "=", value: "0", },{ column: "is_cars", operator: "=", value: "1", } ] as FilterConditions;
        if (!is_admin)  conditions!.push({ column: "is_active", operator: "=", value: "1", });
    
        const sections = (await SELECT(`sections`, { order: "display_order ", conditions: conditions, })) as Section[];

        const cars = (await SELECT(`cars`, {})) as Car[];

        for (let i = 0; i < sections.length; i++) {
            sections[i].items =JSON.parse(`${sections[i].items}`) ?? [];
            for ( let k = 0; k < sections[i].items?.length; k++) {
                const selectedCar = cars.find((p)=> p?.id == sections[i].items[k]) as Car;
                if(!selectedCar) break
                selectedCar.image = selectedCar?.images? selectedCar?.images[0] : "";
                sections[i].items[k]= selectedCar;
            }
            
        }
      
        return sections
    },
 
    insert : async (section : Section) => {
        return await INSERT("sections" , {...section , is_cars :1})
    },

    update : async (id : number , section : Partial<Section>) => {
        return await UPDATE("sections" , section , [{column : "id" , operator : "=" , value : id}])
     
    },

    delete : async (id : number) => {
        return await UPDATE("sections" , { is_deleted : 1 } , [{column : "id" , operator : "=" , value : id}])
    },

}   

export default carsSections